module.exports = __webpack_public_path__ + "static/media/load.7540c713.gif";